<template>
  <v-container
    class="pa-0"
    fluid
  >
    <v-row>
      <v-col
        cols="2"
        class="pb-0"
      >
        <inventory-class-select-element
          v-model="inventoryClassId"
        />
      </v-col>
      <v-col
        v-if="businessRulesGetBoolean('Inventory Sub Class')"
        cols="3"
        class="pb-0"
      >
        <v-autocomplete
          v-model="subClasses"
          label="Sub Classes"
          :items="filteredSubClassesList"
          item-text="name"
          item-value="id"
          multiple
          clearable
        >
          <template #item="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
          <template #selection="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col
        class="text-end mt-4 pb-0"
      >
        <v-btn class="mr-2" color="primary" outlined @click="openImportForm()">
          <v-icon small class="mr-1">fas fa-plus</v-icon>
          Import
        </v-btn>

        <v-btn
          color="primary"
          outlined
          @click="
            () => {
              $refs.itemForm.openDialog();
            }
          "
        >
          <v-icon
            small
            class="mr-1"
          >
            fas fa-plus
          </v-icon>
          new item
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="itemsHeaders"
            :items="items"
            :footer-props="footer"
            :items-per-page="pagination.itemsPerPage"
            :search="search"
            :loading="loading"
            dense
            fixed-header
            :height="windowHeight"
            :server-items-length="total"
            @update:options="updateOptions"
          >
            <template #[`item.inventory_sub_class_ids`]="{ item }">
              <div v-if="item && item.inventory_sub_classes && item.inventory_sub_classes.length">
                <v-chip
                  v-for="sc in item.inventory_sub_classes"
                  :key="sc.id"
                  class="mt-1 mb-1 mr-1"
                  small
                  text-color="white"
                  :color="sc.color ? sc.color : 'black'"
                >
                  <text-highlight :queries="search">
                    {{ sc.name ? sc.name : '' }}
                  </text-highlight>
                </v-chip>
              </div>

              <span v-else>-</span>
            </template>

            <template
              #[`item.inventory_class`]="{ item }"
            >
              <v-chip
                class="mt-0 mb-0"
                small
                :color="item && item.classes ? item.classes.color : 'black'"
                text-color="white"
              >
                {{ item && item.classes ? item.classes.name : '' }}
              </v-chip>
            </template>
            <template
              #[`item.photo`]="{ item }"
            >
              <a
                v-if="item.photo"
                @click="openItemShowImageForm(item.photo, item.mime_type, item.material_id)"
              > <v-icon
                small
                color="primary"
              >
                fa-image
              </v-icon> </a>
            </template>
            <template
              #[`item.material_id`]="{ item }"
            >
              <text-highlight :queries="search">
                {{ item ? item.material_id : '' }}
              </text-highlight>
            </template>
            <template #[`item.departments`]="{ item }">
              <v-tooltip
                v-if="item.departments && item.departments.length > 1"
                top
                color="black"
              >
                <template #activator="{ on }">
                  <span
                    style="color: #1976d2;"
                    v-on="on"
                  >DEPARTMENTS</span>
                </template>
                <span
                  v-for="p in item.departments"
                  :key="`dept-${p.id}`"
                >
                  {{ p.name && p.name !== '-'? `${p.name} ` : '' }} <br>
                </span>
              </v-tooltip>
              <span v-else> <span
                v-for="p in item.departments"
                :key="`dept-${p.id}`"
              >
                <text-highlight :queries="search">{{ p.name && p.name !== '-' ? `${p.name} ` : '' }}</text-highlight>
              </span></span>
            </template>
            <template #[`item.name`]="{ item }">
              <text-highlight :queries="search">
                {{ item ? item.name : '-' }}
              </text-highlight>
            </template>
            <template #[`item.category`]="{ item }">
              <text-highlight :queries="search">
                {{ item ? item.category : '-' }}
              </text-highlight>
            </template>
            <template #[`item.manufacturers`]="{ item }">
              <text-highlight :queries="search">
                {{ item.manufacturers ? item.manufacturers : '-' }}
              </text-highlight>
            </template>
            <template #[`item.uoms`]="{ item }">
              <v-tooltip
                v-if="item.uom_items && item.uom_items.length > 2"
                top
                color="black"
              >
                <template #activator="{ on }">
                  <span
                    style="color: #1976d2;"
                    v-on="on"
                  >UOMS</span>
                </template>
                <span
                  v-for="p in item.uom_items"
                  :key="`uom-${p.id}`"
                >
                  {{ p.name && p.name !== '-'? `${p.name} ` : '' }}<br>
                </span>
              </v-tooltip>
              <span v-else> <span
                v-for="p in item.uom_items"
                :key="`uom-${p.id}`"
              >
                <text-highlight :queries="search">{{ p.name && p.name !== '-' ? `${p.name} ` : '' }}</text-highlight><br>
              </span></span>
              <!-- <text-highlight :queries="search">
                {{ item ? item.uoms : '-' }}
              </text-highlight> -->
            </template>
            <template #[`item.material_properties`]="{ item }">
              <text-highlight :queries="search">
                {{ item.material_properties ? item.material_properties : '-' }}
              </text-highlight>
            </template>
            <template #[`item.lengths`]="{ item }">
              <v-tooltip
                v-if="item.length_items && item.length_items.length > 2"
                top
                color="black"
              >
                <template #activator="{ on }">
                  <span
                    style="color: #1976d2;"
                    v-on="on"
                  >LENGTHS</span>
                </template>
                <span
                  v-for="p in item.length_items"
                  :key="`len-${p.id}`"
                >
                  {{ p.name && p.name !== '-'? `${p.name} ` : '' }}<br>
                </span>
              </v-tooltip>
              <span v-else> <span
                v-for="p in item.length_items"
                :key="`len-${p.id}`"
              >
                <text-highlight :queries="search">{{ p.name && p.name !== '-' ? `${p.name} ` : '' }}</text-highlight>
              </span></span>
            </template>
            <template #[`item.colors`]="{ item }">
              <v-tooltip
                v-if="item.colors && item.colors.length > 2"
                top
                color="black"
              >
                <template #activator="{ on }">
                  <span
                    style="color: #1976d2;"
                    v-on="on"
                  >COLORS</span>
                </template>
                <span
                  v-for="p in item.colors"
                  :key="`col-${p.id}`"
                >
                  {{ p.name && p.name !== '-'? `${p.name} ` : '' }} {{ p.code ? p.code : '' }}<br>
                </span>
              </v-tooltip>
              <span v-else> <span
                v-for="p in item.colors"
                :key="`col-${p.id}`"
              >
                <text-highlight :queries="search">{{ p.name && p.name !== '-' ? `${p.name} ` : '' }} {{ p.code ? p.code : '' }}</text-highlight><br>
              </span></span>
            </template>
            <template #[`item.finishings`]="{ item }">
              <text-highlight :queries="search">
                {{ item.finishings ? item.finishings : '-' }}
              </text-highlight>
            </template>
            <template #[`item.weight`]="{ item }">
              <text-highlight :queries="search">
                {{ item.weight ? `${item.weight} kg/m` : '' }}
              </text-highlight>
            </template>
            <template #[`item.price`]="{ item }">
              <text-highlight :queries="search">
                {{ item.price ? `$${item.price}` : '' }}
              </text-highlight>
            </template>
            <template #[`item.updated_at`]="{ item }">
              <text-highlight :queries="search">
                {{ item.updated_at }}
              </text-highlight>
            </template>
            <template #[`item.actions`]="{ item }">
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="primary"
                outlined
                small
                @click="openItemForm(item)"
              >
                EDIT
              </v-btn>
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="error"
                outlined
                small
                @click="deleteItem(item)"
              >
                DELETE
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <InventoryItemForm
      ref="itemForm"
      @item-creation-success="notifyItemCreationSuccess"
      @item-creation-fail="notifyItemCreationFail"
    />
    <InventoryImportForm
      ref="importForm"
      @item-creation-success="notifyImportSuccess"
      @item-creation-fail="notifyImportFail"
    />
    <InventoryItemShowImageForm
      ref="itemShowImageForm"
    />
  </v-container>
</template>

<script>
import TextHighlight from 'vue-text-highlight';
import { mapGetters, mapState } from 'vuex';
import Bus from '../../bus';
import InventoryItemForm from '../../components/forms/InventoryItemForm';
import InventoryItemShowImageForm from '../../components/forms/InventoryItemShowImageForm';
import InventoryImportForm from '../../components/forms/InventoryImportForm.vue';

export default {
  name: 'Items',
  components: {
    'text-highlight': TextHighlight,
    InventoryItemForm,
    InventoryItemShowImageForm,
    InventoryImportForm,
  },
  filters: {},
  data: () => ({
    items: [],
    subClassesList: [],
    filteredSubClassesList: [],
    classToSubclassesMap: {},
    subClasses: [],
    loading: true,
    footer: {
      'items-per-page-options': [100, 300, 500, -1],
    },
    pagination: {
      itemsPerPage: 100,
      page: 1,
    },
    sort: {
      order_by_first: 'created_at',
      direction_sort: false,
    },
    total: 0,
    topSpaceHeight: 235,
    windowHeight: 1000,
    inventoryClassId: 0,
    inventoryClassInstId: 4,
    inventoryClassPartsId: 11,
    inventoryClassAllId: 0,
  }),
  computed: {
    itemsHeaders() {
      const headers = [];

      if (this.businessRulesGetBoolean('Inventory Classes')) headers.push({ text: 'Class', value: 'inventory_class', width: '5%' });
      if (this.businessRulesGetBoolean('Inventory Sub Class')) headers.push({ text: 'Sub Class', value: 'inventory_sub_class_ids' });

      const materialIdBRName = 'Material Id';
      const materialIdBRValue = this.businessRulesGetBoolean(materialIdBRName);

      if (materialIdBRValue != null && materialIdBRValue !== 0) {
        headers.push({
          text: 'Material Id', value: 'material_id', class: 'material_id', width: '5%',
        });
      }

      headers.push({ text: 'Name', value: 'name' });
      headers.push({ text: 'Colors', value: 'colors', width: '10%' });
      headers.push({ text: 'Lengths', value: 'lengths', width: '10%' });
      headers.push({ text: 'UOM', value: 'uoms', width: '5%' });
      headers.push({ text: 'Weight', value: 'weight', width: '5%' });
      if (this.businessRulesGetBoolean('Manufacturer')) headers.push({ text: 'Category', value: 'category' });

      if (this.inventoryClassId === this.inventoryClassPartsId || this.inventoryClassId === this.inventoryClassAllId) headers.push({ text: 'Price', value: 'price', width: '5%' });

      const manufacturerIdBRName = 'Manufacturer';
      const manufacturerIdBRValue = this.businessRulesGetBoolean(manufacturerIdBRName);
      if (manufacturerIdBRValue != null && manufacturerIdBRValue !== 0) headers.push({ text: 'Manufacturers', value: 'manufacturers' });

      const materialPropertyIdBRName = 'Material Property';
      const materialPropertyIdBRValue = this.businessRulesGetBoolean(materialPropertyIdBRName);
      if (materialPropertyIdBRValue != null && materialPropertyIdBRValue !== 0) headers.push({ text: 'Material Properties', value: 'material_properties' });

      const finishingIdBRName = 'Finishing';
      const finishingIdBRValue = this.businessRulesGetBoolean(finishingIdBRName);
      if (finishingIdBRValue != null && finishingIdBRValue !== 0) headers.push({ text: 'Finishings', value: 'finishings' });

      const itemImageBRName = 'Item Image';
      const itemImageBRValue = this.businessRulesGetBoolean(itemImageBRName);
      if (itemImageBRValue != null && itemImageBRValue !== 0) {
        headers.push({
          text: 'Img', value: 'photo', align: 'center', width: '5%', sortable: false,
        });
      }

      headers.push({ text: 'Updated At', value: 'updated_at' });
      if (this.inventoryClassId === this.inventoryClassPartsId || this.inventoryClassId === this.inventoryClassInstId || this.inventoryClassId === this.inventoryClassAllId) headers.push({ text: 'Departments', value: 'departments' });
      headers.push({
        text: 'Actions', value: 'actions', align: 'end', width: '15%', sortable: false,
      });

      return headers;
    },
    ...mapGetters([
      'businessRulesGetBoolean',
    ]),
    ...mapState({
      search: (state) => state.search,
    }),
  },
  watch:
  {
    pagination() {
      this.getInventoryItems();
    },
    search() {
      this.getInventoryItems();
    },
    inventoryClassId(value) {
      this.getInventoryItems();
      this.filteredSubClassesList = value ? this.classToSubclassesMap[value] : this.subClassesList;
    },
    subClasses() {
      this.getInventoryItems();
    },
  },
  created() {
    this.init();
    this.windowHeight = window.innerHeight - this.topSpaceHeight;
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    async init() {
      await this.getSubClasses();
      await this.getInventoryItems();
    },

    // mergeSubClassesIntoItems(subClassMap, opts = {}) {
    //   const {
    //     enrichIdsToObjects = true,
    //     defaultEmpty = true,
    //   } = opts;

    //   if (!this.items || !Array.isArray(this.items) || this.items.length === 0) return;
    //   if (!subClassMap || typeof subClassMap.get !== 'function') {
    //     if (defaultEmpty) {
    //       for (const item of this.items) {
    //         this.$set(item, 'inventory_sub_class_ids', []);
    //       }
    //     }
    //     return;
    //   }

    //   let subClassById = null;
    //   if (enrichIdsToObjects && Array.isArray(this.subClassesList) && this.subClassesList.length > 0) {
    //     subClassById = new Map(this.subClassesList.map(sc => [sc.id, sc]));
    //   }

    //   for (const item of this.items) {
    //     const itemId = item?.id;

    //     let raw = itemId != null ? subClassMap.get(itemId) : null;

    //     if (!raw) {
    //       this.$set(item, 'inventory_sub_class_ids', defaultEmpty ? [] : raw);
    //       continue;
    //     }

    //     if (raw && typeof raw === 'object' && !Array.isArray(raw) && raw.inventory_sub_class_ids) {
    //       raw = raw.inventory_sub_class_ids;
    //     }

    //     if (!Array.isArray(raw)) {
    //       this.$set(item, 'inventory_sub_class_ids', defaultEmpty ? [] : raw);
    //       continue;
    //     }

    //     const first = raw[0];
    //     const looksLikeObjects = first && typeof first === 'object' && 'id' in first;

    //     if (looksLikeObjects) {
    //       this.$set(item, 'inventory_sub_class_ids', raw);
    //       continue;
    //     }

    //     if (enrichIdsToObjects && subClassById) {
    //       const enriched = raw
    //         .map(id => subClassById.get(id))
    //         .filter(Boolean);

    //       this.$set(item, 'inventory_sub_class_ids', enriched);
    //     } else {
    //       this.$set(item, 'inventory_sub_class_ids', raw);
    //     }
    //   }
    // },
    // async fetchSubClassMapForItemIds(itemIds) {
    //   const submitModel = {
    //     filters: {
    //       inventory_item_ids: itemIds,
    //       is_qty_on_hand_o: 0,
    //     },

    //     pagination: { itemsPerPage: -1, page: 1 },
    //   };

    //   const res = await this.$api.inventoryTag.read(submitModel);
    //   if (!res || !res.data) return new Map();

    //   const map = new Map();
    //   for (const row of res.data) {
    //     const invItemId = row.inventory_item_id;

    //     const incoming = row.inventory_sub_class_ids || [];
    //     const existing = map.get(invItemId) || [];
    //     if (!existing.length && incoming.length) {
    //       map.set(invItemId, incoming);
    //     } else if (!map.has(invItemId)) {
    //       map.set(invItemId, incoming);
    //     }
    //   }

    //   console.log('Subclass lookup returned rows:', res.data.length, 'requested ids:', itemIds.length);

    //   return map;
    // },

    async getInventoryItems() {
      this.loading = true;
      const readModel = {
        filters:
        {
          inventory_class_id: this.inventoryClassId,
          inventory_sub_class_ids: this.subClasses,
        },
        pagination: this.pagination,
        search: this.search,
        sort: this.sort,
        includes: { is_include_item_image: true },
      };
      const res = await this.$api.inventoryItem.readData(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      this.loading = false;
      if (!res || !res.data || res.data.length === 0) {
        this.items = [];
        this.total = 0;
        return;
      }
      this.items = res.data;
      this.total = res.total;
      // const ids = this.items.map(i => i.id);
      // const subClassMap = await this.fetchSubClassMapForItemIds(ids);
      // this.mergeSubClassesIntoItems(subClassMap);
    },

    async getSubClasses() {
      this.subClassesList = await this.$api.inventorySubClass.getList();
      this.classToSubclassesMap = this.subClassesList.reduce((acc, x) => {
        if (!(x.inventory_class_id in acc)) acc[x.inventory_class_id] = [];
        acc[x.inventory_class_id].push(x);
        return acc;
      }, {});
      this.filteredSubClassesList = this.inventoryClassId ? this.classToSubclassesMap[this.inventoryClassId] : this.subClassesList;
    },

    async deleteItem(item) {
      if (!confirm('Are you sure?')) {
        return;
      }

      const res = await this.$api.inventoryItem.softDelete(item.id);
      if (res.err) {
        if (res.errDesc === 'inventory_not_empty') {
          Bus.$emit(
            'alert',
            'error',
            'Error! Inventory for this item is not empty.',
          );
        }
      } else if (res === true) {
        Bus.$emit('alert', 'success', 'Success!');
        this.getInventoryItems();
      } else {
        Bus.$emit('alert', 'error', '');
      }
    },
    openItemForm(item) {
      this.$refs.itemForm.openDialog(item);
    },
    openItemShowImageForm(photo, type, code) {
      this.$refs.itemShowImageForm.openDialog(photo, type, code);
    },
    openImportForm() {
      this.$refs.importForm.openDialog();
    },

    notifyItemCreationSuccess() {
      this.$bus.$emit('showSuccess');
      this.getInventoryItems();
    },
    notifyItemCreationFail() {
      this.$bus.$emit('showError');
    },
    notifyImportSuccess() {
      this.$bus.$emit('showSuccess');
      this.getInventoryItems();
    },
    notifyImportFail() {
      this.$bus.$emit('showError');
    },
    openInventoryImageShowForm() {
      this.$refs.inventoryImageShowForm.openDialog();
    },

    convertedPhoto(photo, mimeType) {
      return `data:${mimeType};base64, ${photo}`;
    },

    onResize() {
      this.windowHeight = window.innerHeight - this.topSpaceHeight;
    },

    updateOptions(newOptions) {
      this.pagination = newOptions;
      this.sort = {
        order_by_first: newOptions.sortBy[0],
        direction_sort: newOptions.sortDesc[0],
      };
    },
  },
};
</script>
<style scoped>
.profile-photo{
  max-width: 100px;
}
</style>
